/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnEvaluationSurveyQuestionType } from './en-evaluation-survey-question-type';
import { EvaluationSurveyAnswerDto } from './evaluation-survey-answer-dto';
 /**
 *
 *
 * @export
 * @interface EvaluationSurveyQuestionDto
 */
export interface EvaluationSurveyQuestionDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof EvaluationSurveyQuestionDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof EvaluationSurveyQuestionDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof EvaluationSurveyQuestionDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof EvaluationSurveyQuestionDto
     */
    deleted: string | null;

    /**
     * Short identifier used in scoring logic (e.g. 'MEMORIA', 'TIMED_UP_GO')
     *
     * @type {string}
     * @memberof EvaluationSurveyQuestionDto
     */
    name: string | null;

    /**
     * @type {string}
     * @memberof EvaluationSurveyQuestionDto
     */
    title: string;

    /**
     * @type {EnEvaluationSurveyQuestionType}
     * @memberof EvaluationSurveyQuestionDto
     */
    type: EnEvaluationSurveyQuestionType;

    /**
     * Hint/sub-text paragraphs shown below the question
     *
     * @type {Array<string>}
     * @memberof EvaluationSurveyQuestionDto
     */
    hints: Array<string> | null;

    /**
     * @type {number}
     * @memberof EvaluationSurveyQuestionDto
     */
    minValue: number | null;

    /**
     * @type {number}
     * @memberof EvaluationSurveyQuestionDto
     */
    maxValue: number | null;

    /**
     * When true this question's value is excluded from the final score
     *
     * @type {boolean}
     * @memberof EvaluationSurveyQuestionDto
     */
    ignore: boolean;

    /**
     * @type {number}
     * @memberof EvaluationSurveyQuestionDto
     */
    sequence: number;

    /**
     * Whether this section may be skipped — meaningful only on root questions
     *
     * @type {boolean}
     * @memberof EvaluationSurveyQuestionDto
     */
    optional: boolean;

    /**
     * @type {Array<EvaluationSurveyQuestionDto>}
     * @memberof EvaluationSurveyQuestionDto
     */
    children: Array<EvaluationSurveyQuestionDto>;

    /**
     * @type {Array<EvaluationSurveyAnswerDto>}
     * @memberof EvaluationSurveyQuestionDto
     */
    answers: Array<EvaluationSurveyAnswerDto>;
}
